// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';

export class EditLocksChangedEvent {
  readonly entity: Enums.EditLockEntity;
  readonly entityIds: string[];

  constructor(data: { [key: string]: any } = {}) {
    this.entity = data.entity === undefined ? Enums.EditLockEntity.Quote : data.entity;
    this.entityIds = (data.entityIds ?? []).map((entityIds: any) =>
      entityIds === undefined ? NIL_UUID : entityIds,
    );
  }

  static zero(): EditLocksChangedEvent {
    const zeroValues: ExcludeMethodsDeep<EditLocksChangedEvent> = {
      entity: Enums.EditLockEntity.Quote,
      entityIds: [],
    };
    return new EditLocksChangedEvent(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type EditLocksChangedEventWireFormat = {
  entity: string;
  entityIds: string[];
};

type NewEditLocksChangedEventProps = PartialDeep<
  EditLocksChangedEvent,
  { recurseIntoArrays: true }
>;
export const NewEditLocksChangedEvent: (
  props: NewEditLocksChangedEventProps,
) => EditLocksChangedEvent = (props) => new EditLocksChangedEvent(props);

type NewEditLocksChangedEventFromWireFormatProps = PartialDeep<
  EditLocksChangedEventWireFormat,
  { recurseIntoArrays: true }
>;
export const NewEditLocksChangedEventFromWireFormat: (
  props: NewEditLocksChangedEventFromWireFormatProps,
) => EditLocksChangedEvent = (props) => new EditLocksChangedEvent(props);
